import { ITableActionParamForRun, Utils } from "@crispico/foundation-react";

export function getFile(resourcePath: string) {
    const resourceName = resourcePath.substring(resourcePath.lastIndexOf("/") + 1);
    return Utils.adjustUrlToServerContext("graniteamf-tide/api/fileRequest/getFile?filename=" + resourceName);
}

export function getFileFromBackgroundProcess(resourcePath: string) {
    const resourceName = resourcePath.substring(resourcePath.lastIndexOf("/") + 1);
    return Utils.adjustUrlToServerContext("graniteamf-tide/api/fileRequest/getFileFromBackgroundProcess/" + resourceName);
}

export function tryJsonParse<T>(values: string): T | undefined {
    try {
        const object: T = JSON.parse(values);
        return object;
    } catch (e) {
        console.error(`Failed to parse values ${values}`, e);
    }
    return undefined;
}